"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyCheckBox = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledFormControlLabel = (0, material_1.styled)(material_1.FormControlLabel)({
  [`&.${material_1.formControlLabelClasses.root}`]: {
    display: "flex",
    margin: "-10px 10px -10px 0"
  },
  [`& .${material_1.formControlLabelClasses.label}`]: {
    marginLeft: 10
  }
});
const StyledCheckbox = (0, material_1.styled)(material_1.Checkbox)({
  [`&.${material_1.checkboxClasses.root}`]: {
    margin: "0 -15px"
  }
});

const SskyCheckBox = props => {
  return react_1.default.createElement(material_1.FormGroup, {
    className: props.className,
    id: props.id
  }, react_1.default.createElement(StyledFormControlLabel, {
    control: react_1.default.createElement(StyledCheckbox, {
      checked: props.checked,
      onChange: props.onChange,
      disabled: props.disabled,
      indeterminate: props.indeterminate,
      icon: props.icon,
      checkedIcon: props.checkedIcon,
      color: props.color,
      "data-testid": props.dataTestId || `testId-${props.id || "checkbox"}`
    }),
    label: props.label || ""
  }));
};

exports.SskyCheckBox = SskyCheckBox;
SskyCheckBox.defaultProps = {
  color: "primary",
  indeterminate: false
};
exports.default = react_1.default.memo(SskyCheckBox);